import { Button, useDisclosure } from '@chakra-ui/react';
import { CustomDialog } from '@packages/wastic-shared';
import React from 'react';

type ProductFilterDialogProps = {
	children: React.ReactNode;
	ref?:     React.Ref<HTMLDivElement>;
};

const ProductFilterDialog = ({ children, ref }: ProductFilterDialogProps) => {
	const { open, setOpen } = useDisclosure();

	return (
		<CustomDialog.Root open={open} onOpenChange={e => setOpen(e.open)}>
			<CustomDialog.Trigger>
				<Button
					minW={'100px'}
					size={'sm'}
					variant={'solid'}
				>
					Filters
				</Button>
			</CustomDialog.Trigger>
			<CustomDialog.Portal>
				<CustomDialog.Content ref={ref}>
					<CustomDialog.Header title={'Product Filters'} />
					{children}
					<CustomDialog.Footer />
				</CustomDialog.Content>
			</CustomDialog.Portal>
		</CustomDialog.Root>
	);
};

export default ProductFilterDialog;